// The user has `ChatSettings` in `src/model/ChatSettings.tsx` (interface).
// And `ProfileAndSettings` likely has `chat_settings: ChatSettings | null`.

let initTimer: ReturnType<typeof setInterval> | null = null;

export const initializeChatWidget = (chatSettings: ChatSettings) => {
  // Profile refreshes call this repeatedly; never re-init a connected widget
  // and never log the token.
  if (window.ChatWidget?.isConnected?.()) return;
  if (initTimer) {
    clearInterval(initTimer);
    initTimer = null;
  }

  // If widget not loaded, load it
  const existingScript = document.querySelector(
    'script[src*="chat-widget.js"]',
  );
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = `${chatSettings.url}/chat-widget.js`;
    script.async = true;
    document.body.appendChild(script);
  }

  const existingStyle = document.querySelector('link[href*="chat-widget.css"]');
  if (!existingStyle) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${chatSettings.url}/chat-widget.css`;
    document.head.appendChild(link);
  }

  let maxTries = 10;
  const timeout = setInterval(() => {
    if (window.ChatWidget) {
      try {
        clearInterval(timeout);
      } catch (error) {
        console.log("Error clearing interval:", error);
      }
      initTimer = null;
      if (window.ChatWidget.isConnected && window.ChatWidget.isConnected()) {
        console.log("Chat widget already connected");
        return;
      }
      console.log("Subscribe campaign_name:", chatSettings.campaign_name);
      window.ChatWidget.init({
        tenantSubdomain: chatSettings.tenant_subdomain,
        apiUrl: chatSettings.url,
        wsUrl: chatSettings.ws_url,
        token: chatSettings.token,
        campaignName: chatSettings.campaign_name,
      });
    } else {
      console.log("ChatWidget not found");
      maxTries--;
      if (maxTries <= 0) {
        console.log("Max tries reached to initialize chat widget");
        clearInterval(timeout);
        initTimer = null;
      }
    }
  }, 1000);

  initTimer = timeout;
};
